import { render, staticRenderFns } from "./ColumnPriceBuy.vue?vue&type=template&id=389592a9"
import script from "./ColumnPriceBuy.vue?vue&type=script&lang=js"
export * from "./ColumnPriceBuy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports